import { SET_BASIC_PARAMS, SET_INSTANCE } from './basic-params-actions';

type State = { viewMode: string; [key: string]: any };

export function basicParams(state: State = { viewMode: 'site' }, { type, payload }: any): State {
  switch (type) {
    case SET_BASIC_PARAMS:
      return payload;
    case SET_INSTANCE:
      return { ...state, instance: payload };
    default:
      return state;
  }
}
